import state from './state'
import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'
console.log('UI Module - Actions:', actions)
console.log('UI Module - State:', state)

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
